import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Shop from "./pages/Shop";
import Product from "./pages/Product";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/product/:slug" element={<Product />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Layout>
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#2C3812",
              color: "#F6EBE2",
              border: "1px solid #1E270D",
              borderRadius: "2px",
              fontFamily: "'DM Sans', sans-serif",
              letterSpacing: "0.04em",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
